<template>
  <Modal
    v-model="shows"
    :title="title"
    ref="modal"
    draggable
    class-name="vertical-center-modal"
    :ok-text="$t('add.index.733618-0')"
    width="830"
    height="600"
    :loading="loading"
    @on-ok="submit"
    @on-cancel="shows = false"
  >
    <Form
      ref="details"
      :model="fromData"
      :rules="ruleValidate"
      label-position="right"
      :label-width="140"
    >
      <Row span="24">
        <Col span="24" v-if="data.type === 'add'">
          <FormItem :label="$t('add.index.733618-1')">
            <div @click="selectAreaClick">
              <span>{{ village.title || $t('add.index.733618-2') }}</span>
            </div>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-3')" prop="Zhuang">
            <Input v-model="fromData.Zhuang" :placeholder="$t('add.index.733618-4')"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-5')" prop="Unit">
            <Input v-model="fromData.Unit" :placeholder="$t('add.index.733618-6')"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-7')" prop="Floor">
            <Input v-model="fromData.Floor" :placeholder="$t('add.index.733618-8')"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-9')" prop="RoomNo">
            <Input v-model="fromData.RoomNo" :placeholder="$t('add.index.733618-10')"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-11')" prop="OwnerName">
            <Input
              v-model="fromData.OwnerName"
              :placeholder="$t('add.index.733618-12')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-13')" prop="OwnerPhone">
            <Input
              v-model="fromData.OwnerPhone"
              :placeholder="$t('add.index.733618-14')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-15')" prop="RoomType">
            <Select v-model="fromData.RoomType" :placeholder="$t('add.index.733618-16')">
              <Option value="1">{{ $t('add.index.733618-17') }}</Option>
              <Option value="2">{{ $t('add.index.733618-18') }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-19')" prop="OrganizationName">
            <Input
              v-model="fromData.OrganizationName"
              :placeholder="$t('add.index.733618-20')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-21')" prop="UserLimitYear">
            <Input
              v-model="fromData.UserLimitYear"
              :placeholder="$t('add.index.733618-22')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-23')" prop="AreaManager">
            <Input
              v-model="fromData.AreaManager"
              :placeholder="$t('add.index.733618-24')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-25')" prop="AreaManagerPhone">
            <Input
              v-model="fromData.AreaManagerPhone"
              :placeholder="$t('add.index.733618-26')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-27')" prop="YearExamState">
            <Select v-model="fromData.YearExamState" :placeholder="$t('add.index.733618-28')">
              <Option value="1">{{ $t('add.index.733618-29') }}</Option>
              <Option value="2">{{ $t('add.index.733618-30') }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-31')">
            <div class="ivu-form-item-content">
              <div
                class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text"
              >
                <input
                  ref="input"
                  type="text"
                  id="suggestId"
                  name="address_detail"
                  :placeholder="$t('add.index.733618-32')"
                  v-show="!address_detail"
                  class="input_style ivu-input ivu-input-default"
                />
                <input
                  type="text"
                  v-show="address_detail"
                  v-model="address_detail"
                  @click="addressDetailClick()"
                  class="input_style ivu-input ivu-input-default"
                />
                <div id="allmap1" style="width: 0px; height: 0px;"></div>
              </div>
            </div>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-33')" prop="Jd">
            <Input v-model="fromData.Jd" :placeholder="$t('add.index.733618-33')"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-34')" prop="Wd">
            <Input v-model="fromData.Wd" :placeholder="$t('add.index.733618-34')"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('add.index.733618-35')" prop="AddressDetail">
            <Input v-model="fromData.AddressDetail" :placeholder="$t('add.index.733618-36')"></Input>
          </FormItem>
        </Col>
        <Col>
          <FormItem :label="$t('add.index.733618-37')" prop="Jdzsyxq" class="f12">
            <DatePicker format="yyyy/MM/dd" type="daterange" placement="bottom-end" :placeholder="$t('add.index.733618-38')"
              style="width: 200px" @on-change="JdzsyxqChange" v-model="Jdzsyxq"></DatePicker>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>

<script>
import api from "../../../../../../api/request.js";
import Cookies from "js-cookie";

const URL = {
  AddRoshRoom: "api/User/AddRoshRoom", // 添加房间（用户）
  GetRoshRoomOne: 'api/User/GetRoshRoomOne', // 获取房间
  EditRoshRoom: 'api/User/EditRoshRoom', // 修改
};

const QUERY = {
  Zhuang: "",
  Unit: "",
  Floor: "",
  RoomNo: "",
  OwnerName: "",
  OwnerPhone: "",
  RoomType: '',
  OrganizationName: '',
  UserLimitYear: '',
  AreaManager: '',
  AreaManagerPhone: '',
  YearExamState: '',
  RoomAddress: "",
  Jd: "",
  Wd: "",
  AddressDetail: '',
  Jdzsyxq_start: '',
  Jdzsyxq_end: ''
}

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      loading: true,
      village: {}, // 村信息
      fromData: { ...QUERY },
      address_detail: null, //详细地址
      userlocation: {
        lng: "",
        lat: ""
      },
      addressText: "",
      ruleValidate: {
        Zhuang: [{ required: true, message: this.$t('add.index.733618-39'), trigger: "change" }],
        Unit: [{ required: true, message: this.$t('add.index.733618-40'), trigger: "change" }],
        Floor: [{ required: true, message: this.$t('add.index.733618-41'), trigger: "change" }],
        RoomNo: [
          { required: true, message: this.$t('add.index.733618-42'), trigger: "change" },
        ],
        OwnerName: [
          { required: true, message: this.$t('add.index.733618-43'), trigger: "change" },
        ],
        OwnerPhone: [
          { required: true, message: this.$t('add.index.733618-44'), trigger: "change" },
        ],
        RoomType: [
          { required: true, message: this.$t('add.index.733618-16'), trigger: "change" },
        ],
        OrganizationName: [{ required: true, message: this.$t('add.index.733618-45'), trigger: "change" }],
        UserLimitYear: [{ required: true, message: this.$t('add.index.733618-46'), trigger: "change" }],
        AreaManager: [{ required: true, message: this.$t('add.index.733618-47'), trigger: "change" }],
        AreaManagerPhone: [{ required: true, message: this.$t('add.index.733618-48'), trigger: "change" }],
        YearExamState: [
          { required: true, message: this.$t('add.index.733618-28'), trigger: "change" },
        ],
        AddressDetail: [{ required: true, message: this.$t('add.index.733618-49'), trigger: "change" }],
      },
      Jdzsyxq: '',
    };
  },
  watch: {
    show(value) {
      if (value) {
        if (this.data.type === 'edit') {
          this.Jdzsyxq = [this.data.row.Jdzsyxq_start, this.data.row.Jdzsyxq_end];
          this.GetRoshRoomOne(this.data.row.Id)
        } else {
          // 清空
          this.fromData = { ...QUERY }
          this.village = {}
          this.Jdzsyxq = '';
          const { grade } = this.data.tree
          if (grade === 4) {
            this.village = this.data.tree
          }
        }
      }
    },
  },
  mounted() {
    this.$nextTick(function() {
      this.initAllmap();
    });
  },
  computed: {
    title() {
      return {
        add: this.$t('add.index.733618-50'),
        edit: this.$t('add.index.733618-51')
      }[this.data.type];
    },
    shows: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      },
    },
  },
  methods: {
    // 加载区域检索地图数据
    initAllmap() {
      var th = this;
      // 创建Map实例
      var map = new BMap.Map("allmap1");
      // 初始化地图,设置中心点坐标，
      var point = new BMap.Point(121.160724, 31.173277);
      // 创建点坐标，汉得公司的经纬度坐标
      map.centerAndZoom(point, 15);
      map.enableScrollWheelZoom();

      //建立一个自动完成的对象
      var ac = new BMap.Autocomplete({
        input: "suggestId",
        location: map
      });

      var myValue;
      //鼠标点击下拉列表后的事件
      ac.addEventListener("onconfirm", function(e) {
        var _value = e.item.value;
        myValue =
          _value.province +
          _value.city +
          _value.district +
          _value.street +
          _value.business;
        this.address_detail = myValue;
        setPlace();
      });

      function setPlace() {
        //清除地图上所有覆盖物
        map.clearOverlays();

        function myFun() {
          //获取第一个智能搜索的结果
          th.userlocation = local.getResults().getPoi(0).point;
          th.fromData.Jd = th.userlocation.lng;
          th.fromData.Wd = th.userlocation.lat;
          th.addressText = local.getResults().getPoi(0).title;
          th.fromData.RoomAddress = th.addressText;
          map.centerAndZoom(new BMap.Point(120.58,28.08), 18);
          //添加标注
          map.addOverlay(new BMap.Marker(th.userlocation));
        }

        //智能搜索
        var local = new BMap.LocalSearch(map, {
          onSearchComplete: myFun
        });
        local.search(myValue);
      }
    },
    // 选择区域
    selectAreaClick() {
      this.$emit("on-area");
    },
    setVillage(data) {
      this.village = data;
    },
    // 获取一条房间信息
    GetRoshRoomOne(id) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetRoshRoomOne}/${id}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      }).then((res) => {
        if (res.Success) {
          this.fromData = res.Data
          this.fromData.RoomType = this.fromData.RoomType.toString()
        }
      });
    },
    submit() {
      this.$refs.details.validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            if (this.village.Zcode) {
              this.AddRoshRoom();
            } else {
              this.$Message["error"]({
                background: true,
                content: this.$t('add.index.733618-52'),
              });
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            }
          } else {
            this.EditRoshRoom();
          }
        } else {
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    AddRoshRoom() {
      if (!this.village.Vcode) {
        this.$Message["error"]({
          background: true,
          content: this.$t('add.index.733618-2'),
        });
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
        return
      }
      let formRoom = {
        Vcode: this.village.Vcode,
        Scode: this.village.Scode,
        Ccode: this.village.Ccode,
        Zcode: this.village.Zcode,
        GroupCode: this.village.GroupCode,
        CompanyCode: this.village.CompanyCode,
        DepartmentCode: this.village.DepartmentCode,
        RoomAddress: this.addressText,
        ...this.fromData,
      };
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: URL.AddRoshRoom,
        data: formRoom,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      }).then((res) => {
        this.shows = false;
        if (res.Success) {
          this.$Message["success"]({
            background: true,
            content: res.Message,
          });
          this.$emit("on-refresh");
        } else {
          this.$Message["error"]({
            background: true,
            content: res.Message,
          });
        }
      });
    },
    // 修改房间信息
    EditRoshRoom() {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: URL.EditRoshRoom,
        data: {...this.fromData},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      }).then((res) => {
        this.shows = false;
        if (res.Success) {
          this.$Message["success"]({
            background: true,
            content: res.Message,
          });
          this.$emit("on-refresh");
        } else {
          this.$Message["error"]({
            background: true,
            content: res.Message,
          });
        }
      });
    },
    // 检定证书有效期
    JdzsyxqChange(date) {
      this.fromData.Jdzsyxq_start = date[0];
      this.fromData.Jdzsyxq_end = date[1];
    },
  },
};
</script>

<style scoped="scoped">
.area-text {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/views/user/mods/add/index.vue